import PortfolioImage from "../Portfolios/Entities/PortfolioImage";
import { useWindowWidth } from "../Context/WindowWidthContext";

function PortfolioThumbnails(
    {
        portfolio,
        piecesColumns,
        tallMode,
        selectedPortfolioPiece,
        setSelectedPortfolioPiece
    }: {
        portfolio: PortfolioImage[],
        piecesColumns: number | undefined,
        tallMode: boolean,
        selectedPortfolioPiece: PortfolioImage,
        setSelectedPortfolioPiece: (PortfolioImage: PortfolioImage) => void,
    }) {
    const windowWidth = useWindowWidth();
    const columns = piecesColumns ?? 3;

    let useSmallIcons = windowWidth <= 767;

    const normalWidth = (useSmallIcons ? 40 : 90);
    // noinspection JSSuspiciousNameCombination
    const normalHeight = normalWidth;

    const tallWidth = useSmallIcons ? 30 : 60;
    const tallHeight = useSmallIcons ? 137 : 273;

    const iconW = tallMode ? tallWidth : normalWidth;
    const iconH = tallMode ? tallHeight : normalHeight;

    const thumbWidth =
        iconW // Image width
        + 13 // Margin
        + 2; // 1px border

    const style = tallMode ? {
        // For grass pages the preview is so tall we calculate the width.
        maxWidth: "100%"
    } : {
        // This allows us to specify the column count
        maxWidth: thumbWidth * columns + "px"
    };

    return (
        <div id="thumbs" style={style}>
            {portfolio.map(piece => (
                <img
                    key={piece.image}
                    style={{
                        width: iconW + "px",
                        height: iconH + "px",
                        display: "inline",
                        margin: "0 13px 9px 0",
                        border: "1px #b28a7b solid"
                    }} onMouseOver={() => {
                    if (selectedPortfolioPiece.image !== piece.image) {
                        setSelectedPortfolioPiece(piece);
                    }
                }}
                    src={"/images/t-" + piece.image}
                    alt={piece.thumbAlt}/>
            ))}
        </div>);
}

export default PortfolioThumbnails;